













import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    GChart,
    ListMessages
  }
})
export default class VisitsVsAdmCharts extends BaseComponent {
  @Prop()
  kpis: any;

  @Prop()
  admKpis: any;

  chartData: any[] = [];

  chartOptions = {
    backgroundColor: 'transparent',
    width: 260,
    height: 70,
    chartArea: { width: '100%', height: '100%' },
    legend: { position: 'labeled', text: 'value', textStyle: { color: 'black' } },
    fontSize: 12,
    pieSliceText: 'none',
    tooltip: { trigger: 'none' },
    slices: [{ color: '102D69' }, { color: 'F5B830' }, { color: 'red' }]
  };

  mounted() {}

  load() {
    this.chartData = [];
    if (!this.kpis.tempoTotalMinutos && !this.admKpis.tempoAtivInterMinutos && !this.admKpis.tempoAfastMinutos) {
      return;
    }
    this.chartData.push(['Tipo', 'Quantidade']);
    this.chartData.push(['Visitas', this.kpis.tempoTotalMinutos]);
    this.chartData.push(['Agenda interna', this.admKpis.tempoAtivInterMinutos]);
    this.chartData.push(['Afastamento', this.admKpis.tempoAfastMinutos]);
  }

  @Watch('kpis', { immediate: true })
  kpisWatch(v) {
    if (!v) {
      return;
    }
    this.load();
  }
}
